<template>
    <div class="detail">
        <wx-header></wx-header>
        <div class="map">
            <div class="filterBox"></div>
            <div class="title-box">
                <p class="title">{{ title }}</p>
            </div>

            <div class="tab-box">
                <ul>
                    <li :class="[index == 1 ? 'active' : '']" @click="getDataDetail(1)">儿童</li>
                    <li :class="[index == 2 ? 'active' : '']" @click="getDataDetail(2)">机构</li>
                    <li :class="[index == 3 ? 'active' : '']" @click="getDataDetail(3)">专家</li>
                </ul>
            </div>
            <div id="mapCharts" style="width: 900px; min-height: 700px"></div>
        </div>
        <div class="right-box">
            <cus-count :cje="total" :title="ptitle"></cus-count>
            <div class="content-box">
                <vue-seamless-scroll v-if="allData.length" :data="allData" class="seamless-warp" :class-option="option">
                    <div class="content" v-for="(item, i) in allData" :key="i">
                        <div class="common leftTop"></div>
                        <div class="common leftBottom"></div>
                        <div class="common rightTop"></div>
                        <div class="common rightBottom"></div>
                        <div class="content-detail">
                            <img :src="item.images_url || defaultURL" alt="" />
                            <div>
                                <h2>{{ ptitle == '专家总数' ? item.headeruser.name : item.name }}</h2>
                                <p class="desc">{{ ptitle == '专家总数' ? item.name : item.area_name || item.description }}</p>
                                <p class="mobile">联系电话：{{ ptitle == '专家总数' ? item.headeruser.mobile : item.mobile }}</p>
                            </div>
                        </div>
                    </div>
                </vue-seamless-scroll>
            </div>
        </div>
    </div>
</template>

<script>
import cusCount from './turnup.vue';
import wxHeader from '@/components/header.vue';
import echarts from 'echarts';
import luoyang from '@/assets/map/luoyang.json';
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
    props: {},
    data() {
        return {
            myChart: '',
            allData: '',
            total: '',
            mapName: '',
            mapData: {},
            mapN: [],
            title: '',
            index: 1,
            ptitle: '儿童总数',
            areaCode: '',
            allData: [],
            isPending: false,
            defaultURL: require('../../assets/img/per-empty.png'),
            childTotal: 0,
            thinkTotal: 0,
            jgTotal: 0,
            orderData: [
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                },
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                },
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                },
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                },
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                },
                {
                    name: '测试滚动',
                    time: '2022 - 03 - 01'
                }
            ]
        };
    },
    computed: {
        option() {
            return {
                limitMoveNum: 6,
                step: 0.2
            };
        }
    },
    created() {},
    mounted() {
        this.getAreas();
        this.title = this.$route.query.flag;
        this.myChart = echarts.init(document.getElementById('mapCharts'), null, {
            devicePixelRatio: 2
        });
        this.mapName = require(`../../assets/map/${this.$route.query.flag}.json`);
        const temp = require(`../../assets/mapData/${this.$route.query.flag}.js`);

        this.mapData = temp.d;
        console.log(this.mapData);
        this.initMap(this.mapName, this.$route.query.flag);
    },
    watch: {
        $route(to, from) {
            console.log(this.$route.query.flag);
        }
    },
    methods: {
        coverData() {
            var res = [];

            for (var i = 0; i < this.mapData.length; i++) {
                var geoCoord = this.mapData[i].geometry.coordinates;

                // debugger;

                if (geoCoord) {
                    res.push({
                        name: this.mapData[i].properties.name,
                        code: this.mapData[i].properties.unique_id,
                        value: geoCoord.concat(this.mapData[i].name)
                    });
                }
            }
            return res;
        },
        getAreas() {
            this.$http.ajax({ url: 'search/areas?parent_id=1' }).then((res) => {
                this.areaCode = res.filter((item) => item.name == this.$route.query.flag)[0].code;
                this.getChildData();
            });
        },
        getAreasMsg() {
            this.$http.ajax({ url: `users/stats/${this.areaCode}/sub/all` }).then((res) => {
                this.childTotal = res.children.total;
                this.thinkTotal = res.thinktank.total;
                this.jgTotal = res.expert.total;
            });
        },
        getChildData() {
            this.$http.ajax({ url: 'users/children', data: { per_page: 100000, area_code: this.areaCode } }).then((res) => {
                this.total = res.total;
                this.allData = res.data;
                this.isPending = false;
            });
        },
        getjgData() {
            this.$http.ajax({ url: 'organizations', data: { per_page: 100000, area_code: this.areaCode } }).then((res) => {
                this.total = res.length;
                this.allData = res;
                this.isPending = false;
            });
        },
        getzjData() {
            this.$http.ajax({ url: 'thinktanks', data: { per_page: 100000, area_code: this.areaCode, type: 2 } }).then((res) => {
                this.total = res.total;
                this.allData = res.data;
                this.isPending = false;
            });
        },
        getData() {
            this.ajax.get('users/stats/4103').then((res) => {
                this.allData.item = res.children.item.mao((item) => {
                    return {
                        value: item.group_count,
                        name: item.group_str
                    };
                });
                this.total = res.children.total;
            });
        },

        initMap(data, name) {
            echarts.registerMap(name, data);
            var html =
                '<span style="position:absolute;top:-1px;left:-1px;z-index:1;width:10px;height:10px;border:2px solid #48e5ff;border-right:none;border-bottom:none;"></span>' +
                '<span style="position:absolute;top:-1px;right:-1px;z-index:1;width:10px;height:10px;border:2px solid #48e5ff;border-left:none;border-bottom:none;"></span>' +
                '<span style="position:absolute;bottom:-1px;left:-1px;z-index:1;width:10px;height:10px;border:2px solid #48e5ff;border-top:none;border-right:none;"></span>' +
                '<span style="position:absolute;right:-1px;bottom:-1px;z-index:1;width:10px;height:10px;border:2px solid #48e5ff;border-top:none;border-left:none;"></span>' +
                '<div style="width:100%;display:flex;align-items:center;justify-content:center;flex-direction:row;margin-top:5px;color:#f0bd26;">';
            var option = {
                tooltip: {
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    show: true,
                    formatter: (params) => {
                        // console.log(params.data);
                        if (params.data && params.data.value.length > 0) {
                            console.log(this);
                            console.log(params.data.code);
                            if (this.areaCode != params.data.code) {
                                this.areaCode = params.data.code;
                                this.getAreasMsg();
                            }

                            var p = `<div style="min-height: 78px; min-width: 200px;max-width: 300px"><p style="padding: 10px 10px 5px 10px;font-size: 18px">${params.name}</p><p style='padding: 0 10px;display: block;word-wrap: break-word;word-break:break-all;white-space:pre-wrap; width: 100%;overflow: hidden; text-align: left;font-family:DIN Condensed Bold;font-size: 14px'><span style="display:block;font-size: 16px">儿童总数：${this.childTotal}</span><span style="display:block; margin: 10px 0px; font-size: 16px">专家数量：${this.thinkTotal}</span><span style="display:block;font-size: 16px">机构数量：${this.jgTotal}</span></p></div>${html}`;

                            return p;
                        }
                    }
                },
                grid: {
                    right: '0%',
                    top: '0%'
                },
                geo: {
                    map: name,
                    itemStyle: {
                        normal: {
                            label: { show: false },
                            color: '#F4F4F4',
                            borderWidth: 0.5, //区域边框宽度
                            borderColor: '#080E1F', //区域边框颜色
                            // areaColor: "#5389EB", //区域颜色
                            areaColor: 'rgba(55,113,255,0.3)' //区域颜色
                        },
                        emphasis: {
                            label: { show: false },
                            borderWidth: 0.5,
                            borderColor: '#4b0082',
                            areaColor: '#ffdead'
                        }
                    }
                    // // aspectScale: 0.8,
                    // layoutCenter: ['49%', '45%'], //地图位置
                    // layoutSize: '80%',
                    // zoom: 1.2
                },
                series: [
                    {
                        name: '兰考县各乡镇养老机构',
                        type: 'map',
                        mapType: name,
                        label: {
                            normal: {
                                textStyle: {
                                    fontSize: 15,
                                    fontWeight: 'bold',
                                    color: '#fff'
                                }
                            }
                        },
                        aspectScale: 0.75,
                        itemStyle: {
                            normal: {
                                label: { show: false },
                                color: '#F4F4F4',
                                borderWidth: 0.5, //区域边框宽度
                                borderColor: '#080E1F', //区域边框颜色
                                // areaColor: "#5389EB", //区域颜色
                                areaColor: 'rgba(55,113,255,0.3)' //区域颜色
                            },
                            emphasis: {
                                label: { show: false },
                                borderWidth: 0.5,
                                borderColor: '#4b0082',
                                areaColor: 'rgba(55,113,255,0.3)'
                            }
                        }
                    },
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        symbol: 'circle',
                        legendHoverLink: true,
                        zlevel: 2,
                        symbolSize: 8,
                        rippleEffect: {
                            //坐标点动画
                            period: 3,
                            scale: 6,
                            brushType: 'fill'
                        },
                        // legendHoverLink: true,

                        itemStyle: {
                            //坐标点颜色
                            normal: {
                                show: true,
                                color: '#00ffff',
                                shadowBlur: 10,
                                shadowColor: 'rgba(0,255,255,0.5)'
                            },
                            emphasis: {
                                areaColor: '#f00'
                            }
                        },
                        data: this.coverData(this.mapN),
                        showEffectOn: 'render',
                        // symbolSize: function (val) {
                        //     return val[2] / 10;
                        // },
                        hoverAnimation: true,
                        zlevel: 1
                    }
                ]
            };

            this.myChart.setOption(option);
        },
        getDataDetail(i) {
            if (this.isPending) return;
            this.isPending = true;
            this.index = i;

            if (i == 1) {
                this.ptitle = '儿童总数';
                this.getChildData();
            } else if (i == 2) {
                this.ptitle = '机构总数';
                this.getjgData();
            } else {
                this.ptitle = '专家总数';
                this.getzjData();
            }
        }
    },
    components: {
        wxHeader,
        cusCount,
        vueSeamlessScroll
    }
};
</script>
<style scoped lang="scss">
.detail {
    .map {
        position: absolute;
        top: 160px;
        left: 40px;
        bottom: 20px;
        border: 1px solid #54c0f9;
        width: 45%;
        .filterBox {
            background: rgba($color: #000000, $alpha: 0.4);
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100%;
            z-index: -1;
            -webkit-filter: blur(9px);
            -moz-filter: blur(9px);
            -o-filter: blur(9px);
            -ms-filter: blur(9px);
            filter: blur(30px);
        }
        .title-box {
            display: flex;
            justify-content: center;
        }
        .title {
            background: rgba($color: #00c2ff, $alpha: 0.4);
            color: #ffffff;
            font-weight: bold;
            font-size: 20px;
            padding: 5px 60px;
            display: inline-block;
            border-radius: 4px;
            margin: 40px auto 50px auto;
        }
        .tab-box {
            width: 300px;
            margin-left: 50px;
            ul {
                display: flex;
                list-style: none;
                li {
                    flex: 1;
                    color: #ffffff;
                    height: 50px;
                    line-height: 50px;
                    background: linear-gradient(to bottom, #34588d, #264e66);
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
    .right-box {
        position: absolute;
        top: 140px;
        right: 40px;
        bottom: 20px;
        box-sizing: border-box;
        width: 45%;
    }
    .content-box {
        margin-top: 50px;
    }
    .content {
        box-sizing: border-box;
        position: relative;
        min-height: 200px;
        border: 1px solid rgba($color: #00c2ff, $alpha: 0.6);
        margin-bottom: 40px;
        .common {
            z-index: 2500;
            position: absolute;
            width: 19px;
            height: 19px;
            background: rgba(0, 0, 0, 0);
            border: 4px solid #1fa5f1;
        }
        .leftTop {
            top: -2px;
            left: -2px;
            border-right: none;
            border-bottom: none;
            border-top-left-radius: 6px;
        }
        .rightTop {
            top: -2px;
            right: -2px;
            border-left: none;
            border-bottom: none;
            border-top-right-radius: 6px;
        }
        .leftBottom {
            bottom: -2px;
            left: -2px;
            border-right: none;
            border-top: none;
            border-bottom-left-radius: 6px;
        }
        .rightBottom {
            bottom: -2px;
            right: -2px;
            border-left: none;
            border-top: none;
            border-bottom-right-radius: 6px;
        }
        .content-detail {
            display: flex;
            padding: 20px;
            box-sizing: border-box;
            flex-direction: row;
            img {
                width: 150px;
                height: 150px;
                border-radius: 8px;
                margin-right: 30px;
                flex-shrink: 0;
            }
            h2 {
                font-size: 28px;
                color: #ffffff;
                font-weight: bold;
            }
            .desc,
            .mobile {
                font-size: 22px;
                color: #ffffff;
                margin-top: 10px;
                overflow: hidden;

                text-overflow: ellipsis;

                display: -webkit-box;

                -webkit-box-orient: vertical;

                -webkit-line-clamp: 2;
            }
            .mobile {
                align-self: flex-end;
            }
        }
    }
}
.active {
    background: linear-gradient(to right, #54c0f9, #00c2ff) !important;
    // color: 66 !important;
    font-weight: bold;
}
.seamless-warp {
    overflow: hidden;
    height: 700px;
    width: 100%;
}
</style>
